import * as actions from '../actions'

var defaultState = false

export default function profile(state = defaultState, action) {
    switch (action.type) {

        case actions.IS_READY:
            return true

        default:
            return state

    }
}



// WEBPACK FOOTER //
// ./state/reducers/isReady.js